"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentCreatedToJSON = exports.EnrollmentCreatedFromJSONTyped = exports.EnrollmentCreatedFromJSON = void 0;
const _1 = require("./");
function EnrollmentCreatedFromJSON(json) {
    return EnrollmentCreatedFromJSONTyped(json, false);
}
exports.EnrollmentCreatedFromJSON = EnrollmentCreatedFromJSON;
function EnrollmentCreatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'jwt': json['jwt'],
        'enrollment': _1.EnrollmentFromJSON(json['enrollment']),
    };
}
exports.EnrollmentCreatedFromJSONTyped = EnrollmentCreatedFromJSONTyped;
function EnrollmentCreatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'jwt': value.jwt,
        'enrollment': _1.EnrollmentToJSON(value.enrollment),
    };
}
exports.EnrollmentCreatedToJSON = EnrollmentCreatedToJSON;
//# sourceMappingURL=EnrollmentCreated.js.map